import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_266cf7bd-85bf-4fa7-83fe-d09732430dba/artifacts/urov4aah_Screenshot%202026-02-16%20at%209.23.56%E2%80%AFPM.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="bg-white rounded-2xl p-2">
                <img 
                  src={LOGO_URL} 
                  alt="Bayside Birth & Pelvic Health" 
                  className="h-16 w-auto"
                />
              </div>
            </div>
            <h3 className="text-xl font-medium">Bayside Birth & Pelvic Health</h3>
            <p className="text-primary-foreground/80 leading-relaxed">
              Thoughtful care, personalized for you, in the beautiful Florida Keys.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/" 
                data-testid="footer-link-home"
                className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/services" 
                data-testid="footer-link-services"
                className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                Services
              </Link>
              <Link 
                to="/about" 
                data-testid="footer-link-about"
                className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                About
              </Link>
              <Link 
                to="/contact" 
                data-testid="footer-link-contact"
                className="text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-medium">Get in Touch</h4>
            <div className="space-y-3">
              <a 
                href="tel:+13055221054" 
                data-testid="footer-phone"
                className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>(305) 522-1054</span>
              </a>
              <a 
                href="mailto:margaret@baysidehealth-flkeys.com" 
                data-testid="footer-email"
                className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>margaret@baysidehealth-flkeys.com</span>
              </a>
              <a
                href="https://maps.google.com/?q=90290+Overseas+Hwy+Suite+106+Tavernier+FL+33070"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address"
                className="flex items-start gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors"
              >
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>
                  The Turek Building<br />
                  90290 Overseas Hwy, Suite 106<br />
                  Tavernier, FL 33070
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-primary-foreground/70">
              © {currentYear} Bayside Birth & Pelvic Health. All rights reserved.
            </p>
            <p className="flex items-center gap-2 text-sm text-primary-foreground/70">
              Made with <Heart className="w-4 h-4 text-secondary" /> in the Florida Keys
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
